import { DataSecurityMonitorType } from '@sonar-software/sonar-core';
import { enumNumericValues } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarText } from '@ui/text';

import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { monitorParentType, monitorTypeLabel, MonitorTypeTag } from './MonitorTypeTag';
import { Select, Space } from 'antd';

export interface MonitorTypeFilterProps {
	onTypeSelect: (typeId?: number) => void;
}

const monitorTypeOptions = enumNumericValues(DataSecurityMonitorType)
	.filter((type: DataSecurityMonitorType) =>
		monitorParentType[ type ] === undefined ||
		monitorParentType[ type ] === type)
	.map((value) => ({
		label: <MonitorTypeTag monitorTypeId={ value } />,
		value
	}));

function handleFilter(input: string, option: { value: number }): boolean {
	if (!input || !option) {
		return true;
	}

	const label = monitorTypeLabel[ option.value ];

	if (!label) {
		return true;
	}

	return label.toLowerCase().includes(input.toLowerCase());
}

export const MonitorTypeFilter: React.FC<MonitorTypeFilterProps> = ({ onTypeSelect }) =>
	<Space direction='vertical'>
		<SonarText>{ COPY_SPECIFIC.TYPE }</SonarText>
		<Select
			allowClear
			className='type-select'
			filterOption={ handleFilter }
			onChange={ onTypeSelect }
			options={ monitorTypeOptions }
			placeholder={ PLACEHOLDERS_COPY.FILTER_BY(COPY_SPECIFIC.TYPE) }
			showSearch />
	</Space>;
